export default __webpack_public_path__ + "unreal-engine-4.a43e137a.png";